import React from "react";
import SVG_check_mark from "../../../assets/images/vector/components/form/check_mark.svg";

export const CreateTitle = ({ title, hideTrial }) => {
  return (
    <>
      <p className="PgESM-FP-T__title">{title}</p>
      <p className="PgESM-FP-T__subTitle">
        <span><img src={SVG_check_mark} alt="" />Sin tarjeta de crédito</span>
        {!hideTrial && <span><img src={SVG_check_mark} alt="" />Prueba de tiempo ilimitado</span>}
      </p>
    </>
  );
};
export const DEFAULT_OPTION = {
  title: <CreateTitle title="Ingresa tu email para comenzar tu PRUEBA GRATIS y recibe una idea de producto en tu correo" />,
  redirectButton: {
    buttonText: "Prueba AMZScout gratis!"
  },
  form: {
    buttonText: "Prueba AMZScout gratis!",
    placeholder: "example@gmail.com"
  }
};

